import React, { useState } from 'react';
import { AuthHeader } from '../components/AuthHeader';
import { CronTabNavigation } from '../components/cron/CronTabNavigation';
import { CronJobForm } from '../components/cron/CronJobForm';
import { CronJobList } from '../components/cron/CronJobList';
type TabType = 'create' | 'manage';
export const CRONModule: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('create');
  return <div className="min-h-screen bg-gray-50" data-id="element-1176">
      <AuthHeader title="CRON Job Scheduler" showBackButton={true} data-id="element-1177" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-1178">
        <p className="text-gray-600 mb-8" data-id="element-1179">
          Create, manage, and monitor scheduled data jobs
        </p>
        <CronTabNavigation activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-1180" />
        <div className="mt-6" data-id="element-1181">
          {activeTab === 'create' && <CronJobForm data-id="element-1182" />}
          {activeTab === 'manage' && <CronJobList data-id="element-1183" />}
        </div>
      </div>
    </div>;
};